import AsyncGroupFactory from '@/Factories/AsyncGroupFactory';
import ComponentManager from '@/Management/ComponentManager';
import PropertyGroupBoxViewModelT from '@/ViewModels/Controls/PropertyGroupBoxViewModel';
import PropertyGroupBoxT from '@/Controls/PropertyGroupBox';

export default class DefaultGroupFactory extends AsyncGroupFactory {

    private PropertyGroupBoxViewModel = ComponentManager.getViewModel<typeof PropertyGroupBoxViewModelT>('PropertyGroupBoxViewModel');
    private PropertyGroupBox = ComponentManager.getControl<typeof PropertyGroupBoxT>('PropertyGroupBox');

    /**
     * @override
     */
    viewModel: PropertyGroupBoxViewModelT;

    public constructor(params: any) {
        super(params);
        this.layout = 'OneColumnLayout';
    }

    /**
     * @override 
     */
    protected createViewModel(): PropertyGroupBoxViewModelT {
        return new this.PropertyGroupBoxViewModel({
            context: this.context,
            layout: this.layout,
            isSummaryViewMode: this.isSummaryViewMode,
            detailViewGroups: this.detailViewGroup.detailViewGroups,
            detailViewItems: this.detailViewGroup.items,
            parentLocator: this.locator,
            locator: this.detailViewGroup.name
        });
    }

    /**
     * @override 
     */
    protected createControl(): PropertyGroupBoxT {
        return new this.PropertyGroupBox(this.viewModel);
    }
}

ComponentManager.setFactory('Default', DefaultGroupFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');